import { useEffect, MutableRefObject } from "react";

export function useAutofocus(
  ref: MutableRefObject<HTMLInputElement | null>,
  precondition: boolean
): void {
  useEffect(() => {
    if (ref.current && precondition) {
      ref.current.focus();
    }
  }, [ref, precondition]);
}
